export const TOGGLE_CUSTOMISATION_WIDGET = 'TOGGLE_CUSTOMISATION_WIDGET';
export const OPEN_CUSTOMISATION_WIDGET = 'OPEN_CUSTOMISATION_WIDGET';
